import { render, staticRenderFns } from "./MealrequestMove.vue?vue&type=template&id=6264af51&"
import script from "./MealrequestMove.vue?vue&type=script&lang=js&"
export * from "./MealrequestMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports